import React from 'react';
import './logIn.style.sass';
import TopOfNav from "../../layouts/topOfNav/topOfNav.component";
import StickyNav from "../../layouts/stickyNav/stickyNav.component";
import DrawerNav from "../../components/drawer/drawer.component";
import NavBar from "../../layouts/navbar/navbar.component";
import Footer from "../../layouts/footer/footer.component";
import LoginLayout from "../../layouts/logIn/login.layout";

const LogInPage = () => {
    return (
        <div>
            <TopOfNav />
            <StickyNav />
            <DrawerNav />
            <NavBar />
            <LoginLayout />
            <Footer />
        </div>
    );
};

export default LogInPage;